export default __webpack_public_path__ + "static/media/icon_filter_enabled.3d35694a.svg";